import React from 'react'

const Award = () => {
  return (
    <div className='container mt-5'>
      <div className='row'>
      <div className='col-6 p-5'>
          <img src='Media/largestBroker.svg'/>
        </div>
        <div className='col-6 p-5 mt-5'>
          <h1>Largest stock broker in India</h1>
          <p className='mb-5'>2+ million Zerodha clients contribute to over 15% of all retail order volumes in India daily by trading and investing in:</p>
          <div className='row'>
            <div className='col-6'>
              <ul>
                <li><p>Futures and Options</p></li>
                <li><p>Commodity derivatives</p></li>
                <li><p>Currency derivatives</p></li>
              </ul>
            </div>
            <div className='col-6'>
            <ul>
              <li><p>Equity markets</p></li>
              <li><p>Mutual Funds</p></li>
              <li><p>Government Securities</p></li>
            </ul>
            </div>
          </div>
          <img src='Media/pressLogos.png' style={{width:'95%'}}/>
        </div>
      </div>
    </div>
  );
};

export default Award;